import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChatPage } from '../views/ChatPage';
import { LoadingScreen } from '../views/LoadingScreen';
import { AuthFailScreen } from '../views/AuthFailScreen';
import { useAuthStore } from '../store/authStore';
import { MESSAGE_EVENTS } from '../constants/messageEvents';
import { login } from '../services/authService';

export function App() {
  const {
    authStatus,
    setAuth,
    setSessionId,
    setAiToken,
    setRefreshToken,
    setAuthStatus,
  } = useAuthStore();

  useEffect(() => {
    window.parent.postMessage({ type: MESSAGE_EVENTS.CHATBOT_READY }, '*');

    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type !== MESSAGE_EVENTS.CHATBOT_AUTH || !event.data?.auth)
        return;

      const auth = event.data.auth;
      setAuth(auth);
      setAuthStatus('loading');

      try {
        const data = await login(auth);
        setSessionId(data.session_id);
        setAiToken(data.access_token);
        setRefreshToken(data.refresh_token);
        setAuthStatus('success');
      } catch {
        setAuthStatus('error');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [setAuth, setSessionId, setAiToken, setRefreshToken, setAuthStatus]);

  if (authStatus === 'error') return <AuthFailScreen />;
  if (authStatus !== 'success') return <LoadingScreen />;

  return (
    <Routes>
      <Route path="/" element={<ChatPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
